import React from "react";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "#e0e0e0",
        // padding: "15px 20px",
        marginTop:"10px",
        textAlign: "center",
        fontSize: "1rem",
        width: "100%",
        position: "relative",
        bottom: 0,
        color: "#707070",
      }}
    >

      <div style={{ marginBlock: "10px" }}>
        <a 
          href="https://gabrielsenna.com/politica-de-privacidade-crm/" 
          style={{ color: "#707070", textDecoration: "none", margin: "0 10px" }}
        >
          Política de Privacidade
        </a>
        |
        <a 
          href="https://gabrielsenna.com/termos-de-uso-crm/" 
          style={{ color: "#707070", textDecoration: "none", margin: "0 10px" }}
        >
          Termos de Uso
        </a>
        |
        <a 
          href="https://gabrielsenna.com/ideias-para-melhorias/" 
          style={{ color: "#707070", textDecoration: "none", margin: "0 10px" }}
        >
          Sugestões de melhoria
        </a>




        
      </div>

      <p style={{fontSize:".8rem"}}>Desenvolvido por Gabriel Senna ®</p>

    </footer>
  );
};

export default Footer;
